import React, {useEffect, useState} from 'react';
import _ from "lodash";
import AddEditPinterestBoard from "./add-edit-pinterest-board";
import PinterestBoardFilters from "./pinterest-board-filters";
import {searchPinterestBoardsWithSearchCriteria} from "../../services/pinterest-board-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PINTEREST_BOARD_FIELDS_LIST} from "../../constants/pinterest-board.constant";
import GoToLink from "../../../common/ui/go-to-link";
import {syncPinterestAccount, syncPinterestBoards} from "../../services/pinterest-api-service";
import {start} from "node:repl";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const defaultFilterCriteria: any = {};

const PinterestBoardsList = ({pinterestAccount}) => {
    const [pinterestBoardsList, setPinterestBoardsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPinterestBoardList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const pinterestBoardListResult = await searchPinterestBoardsWithSearchCriteria(searchCriteriaList);

        setPinterestBoardsList(pinterestBoardListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        refreshPinterestBoardList();
    }, [filterCriteria]);

    const refreshPinterestBoardList = async () => {
        await getPinterestBoardList();
    }

    const startPinterestBoardsSync = async (pinterestAccount) => {
        setDataFetchInProgress(true);
        await syncPinterestBoards(pinterestAccount?.id);

        await refreshPinterestBoardList();
        setDataFetchInProgress(false);
    }


    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-fit">
                    <div className={'text-xl ml-2'}>
                        Pinterest Board
                    </div>

                    {/*<PinterestBoardFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center flex items-center justify-end">
                    {pinterestAccount?.id &&
                        <div className="flex justify-center">
                            <button
                                className="button-green px-3 py-1 flex items-center justify-center"
                                onClick={() => {
                                    startPinterestBoardsSync(pinterestAccount);
                                }}>
                                <span>Sync Boards</span>
                            </button>
                        </div>
                    }

                    <div className="ml-2">
                        <AddEditPinterestBoard
                            isAddPinterestBoard={true}
                            refreshPinterestBoardList={refreshPinterestBoardList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={pinterestBoardsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Pinterest Boards'}/>

                    {pinterestBoardsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {PINTEREST_BOARD_FIELDS_LIST?.map((pinterestBoardField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${pinterestBoardField?.cssClass}`}>{pinterestBoardField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {pinterestBoardsList?.map((pinterestBoard, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {PINTEREST_BOARD_FIELDS_LIST?.map((pinterestBoardField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${pinterestBoardField?.cssClass}`}>
                                                {pinterestBoardField?.optionsMap &&
                                                    <>{pinterestBoardField?.optionsMap[pinterestBoard[pinterestBoardField?.attribute]]?.name}</>
                                                }

                                                {!pinterestBoardField?.optionsMap && !pinterestBoardField?.isImage &&
                                                    <>
                                                        {pinterestBoard[pinterestBoardField?.attribute]}

                                                        {pinterestBoardField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {pinterestBoard[pinterestBoardField?.secondaryAttribute]}
                                                            </div>
                                                        }

                                                        {pinterestBoardField?.secondaryAttributes &&
                                                            <>
                                                                {pinterestBoardField?.secondaryAttributes?.map((secondaryAttribute, secondaryIndex) => (
                                                                    <div key={`secondary-${secondaryIndex}`}
                                                                         className={'text-gray-500 text-sm'}>
                                                                        {pinterestBoard[secondaryAttribute]}
                                                                    </div>
                                                                ))}
                                                            </>
                                                        }
                                                    </>
                                                }

                                                {pinterestBoardField?.isImage &&
                                                    <div className={`flex justify-center items-center`}>
                                                        <ProductImageSmall
                                                            imageUrl={pinterestBoard[pinterestBoardField?.parent][pinterestBoardField?.attribute]}/>
                                                    </div>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                            {/*<button
                                                className="button-green px-4 py-2 flex items-center justify-center"
                                                onClick={() => {
                                                    startPinterestBoardsSync(pinterestAccount);
                                                }}>
                                                <span>Sync Boards</span>
                                            </button>*/}

                                            <AddEditPinterestBoard
                                                isEditPinterestBoard={true}
                                                selectedPinterestBoard={pinterestBoard}
                                                refreshPinterestBoardList={refreshPinterestBoardList}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default PinterestBoardsList
